import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Modal, ShowAt } from '../../common';
import { bookSelectors, bookOperations } from '../../../state/book';
import { recurrenceSelectors } from '../../../state/recurrence';
import { modalOperations } from '../../../state/modal';

import BookUpdateModalDesktop from './BookUpdateModalDesktop';
import BookUpdateModalMobile from './BookUpdateModalMobile';

import keys from '../modalKeys';

import '../_style.css';

function BookUpdateModal(props) {
  const { clearModals } = props;

  return (
    <div>
      <ShowAt breakpoint="900AndAbove">
        <Modal modalKey={keys.BOOK_UPDATE_MODAL} onOverlayClick={clearModals}>
          <BookUpdateModalDesktop {...props} />
        </Modal>
      </ShowAt>
      <ShowAt breakpoint="900AndBelow">
        <Modal modalKey={keys.BOOK_UPDATE_MODAL} mobile>
          <BookUpdateModalMobile {...props} />
        </Modal>
      </ShowAt>
    </div>
  );
}

const mapStateToProps = state => ({
  selectedResource: bookSelectors.getSelectedResource(state),
  subject: bookSelectors.getSubject(state),
  date: bookSelectors.getDate(state),
  time: bookSelectors.getTime(state),
  isValidDate: bookSelectors.isValidDate(state),
  isMessageValid: bookSelectors.isMessageValid(state),
  isSubjectValid: bookSelectors.isSubjectValid(state),
  isReadyToSubmit: bookSelectors.isReadyToSubmit(state),
  isSubmitting: bookSelectors.isSubmitting(state),
  message: bookSelectors.getMessage(state),
  reminder: bookSelectors.getReminder(state),
  additionalEquipment: bookSelectors.getAdditionalEquipment(state),
  recurrenceType: recurrenceSelectors.getRecurrenceType(state),
  bookForPerson: bookSelectors.getBookForPerson(state),
  bookForLoading: bookSelectors.isBookForLoading(state),
  bookForSuggestions: bookSelectors.getBookForSuggestions(state),
  attendeesSearchTerm: bookSelectors.getAttendeesSearchTerm(state),
  attendeesSuggestions: bookSelectors.getAttendeesSuggestions(state),
  selectedAttendees: bookSelectors.getSelectedAttendees(state),
  attendeesLoading: bookSelectors.areAttendeesLoading(state),
  seating: bookSelectors.getSeating(state)
});

const mapDispatchToProps = dispatch => ({
  updateDate: date => dispatch(bookOperations.updateDate(date)),
  updateTime: time => dispatch(bookOperations.updateTime(time)),
  updateSubject: subject => dispatch(bookOperations.updateSubject(subject)),
  updateMessage: message => dispatch(bookOperations.updateMessage(message)),
  updateReminder: reminder => dispatch(bookOperations.updateReminder(reminder)),
  clearModals: () => dispatch(modalOperations.clearModals()),
  updatePerson: person => dispatch(bookOperations.updateBookForPerson(person)),
  loadSuggestions: term => dispatch(bookOperations.loadBookForSuggestions(term)),
  updateTerm: term => dispatch(bookOperations.setAttendeesSearchTerm(term)),
  updateSelectedPeople: attendees => dispatch(bookOperations.updateSelectedAttendees(attendees)),
  fetchPeople: () => dispatch(bookOperations.fetchAttendees()),
  goBackToDetail: () => {
    dispatch(bookOperations.resetStateFromCache());
    dispatch(modalOperations.popModal());
  }
});

BookUpdateModal.propTypes = {
  clearModals: PropTypes.func.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(BookUpdateModal);
